var map = {
	"./allot.js": "6af7",
	"./approval.js": "a912",
	"./bound.js": "ad6f",
	"./check.js": "15d4",
	"./dict.js": "b705",
	"./file.js": "3f5e",
	"./inventory.js": "f3a3",
	"./materiel.js": "5719",
	"./organization.js": "d368",
	"./position.js": "6e6f",
	"./project.js": "24d2",
	"./requisition.js": "2a44",
	"./settings.js": "34b7",
	"./stash.js": "5e18",
	"./statistics.js": "48fb",
	"./supplier.js": "a6b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9d6";